import {Component} from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { CxoneOrderManagementService } from "../../../services/cxone-order-management.service";
import { NgClass } from "@angular/common";
import { MatTooltipModule } from "@angular/material/tooltip";

@Component({
    standalone: true,
    imports: [NgClass, MatTooltipModule],
    template: `
        <div [style.overflow]="'hidden'" [style.textOverflow]="'ellipsis'" class="h-100 d-flex align-items-center container-max-width"
        [matTooltip]="isTextHasEllipsis(textStatus) ? status?.name : undefined"
        matTooltipPosition="after" matTooltipClass="custom-tooltip-dropdown">
          <div class="select-container d-flex w-100 justify-content-between" [ngClass]="{disabled: disable}">
            <div [style.overflow]="'hidden'" [style.textOverflow]="'ellipsis'" class="d-flex">
                <i class="icon-status">
                    <svg class="icon-16 fill-iconDefault">
                    <use [attr.href]="status.iconPath"></use>
                    </svg>
                </i>
                <p #textStatus class="status-name">
                    {{status?.name}}
                </p>
            </div>
            <i class="icon-arrow">
                <svg class="icon-13 icon">
                    <use href="../App_Themes/CXone/icons/arrow-down.svg#arrow-down"></use>
                </svg>
            </i>
          </div>
        </div>
    `,
    styles: [
        `
            .container-max-width {
                max-width: 85% !important
            }

            .icon-status {
                padding-right: 8px;
                padding-left: 12px;
            }
            .icon-arrow {
                justify-self: end;
                padding-right: 12px;
            }
            .status-name {
                font-family: "OpenSans";
                font-size: 13px;
                font-weight: 400;
                margin: 0;
                padding-top: 2px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                max-width: 115px
            }
            .select-container {
                border: 1px solid #B8C5CC;
                height: 36px;
                align-items: center;
                background-color: #FFFFFF;
            }
            .disabled {
                background: rgb(248, 248, 248) 0% 0% no-repeat padding-box !important;
                border: 1px solid rgb(208, 210, 211) !important;
                pointer-events: none;

                .status-name {
                    color: rgb(112, 126, 141) !important;
                }

                .icon {
                    fill: rgb(173, 173, 173) !important;
                }
            }
            .icon {
                fill: #758994 !important;
            }
            ::ng-deep .custom-tooltip-dropdown {
                background-color: white;
                border: 1px solid #D2D8DB;
                -webkit-box-shadow: -2px 3px 39px 6px rgba(210, 216, 219, 0.27);
                -moz-box-shadow: -2px 3px 39px 6px rgba(210, 216, 219, 0.27);
                box-shadow: -2px 3px 39px 6px rgba(210, 216, 219, 0.27);
                max-width: 310px;
                border-radius: 0 !important;
                color: #333333 !important;
                font-family: 'SOL Sans' !important; 
                font-weight: 400 !important;
                font-size: 13px !important;
                overflow-wrap: break-word;
            }
            ::ng-deep .mdc-tooltip__surface {
                font-family: 'SOL Sans' !important;
                background-color: white !important;
                padding: 8px;
                color: #333333 !important;
            }         
        `
    ]
})
export class StatusCellRenderer implements ICellRendererAngularComp {

    status = null;
    disable = false;

    constructor(
        private orderManagementService: CxoneOrderManagementService
    ) {}

    public params!: ICellRendererParams;

    agInit(params: ICellRendererParams): void {
        this.params = params;
        this.status = this.orderManagementService.getStatusById(params.value);
        this.disable = (params as any).disable;
    }

    refresh() {
        return false
    }

    isTextHasEllipsis(element: HTMLElement): boolean {
        return element.scrollWidth > element.clientWidth;
    }
}
